import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M854.343529,1317.68471 L503.209412,966.550588 L583.058824,886.701176 L854.343529,1157.98588 L1374.55059,637.665882 L1454.4,717.628235 L854.343529,1317.68471 Z M960.056471,0 C430.701176,0 0.0564705882,430.644706 0.0564705882,960 C0.0564705882,1489.35529 430.701176,1920 960.056471,1920 C1489.29882,1920 1920.05647,1489.35529 1920.05647,960 C1920.05647,430.644706 1489.29882,0 960.056471,0 L960.056471,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCompleteSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCompleteSolid, _Component);

  var _super = _createSuper(IconCompleteSolid);

  function IconCompleteSolid() {
    _classCallCheck(this, IconCompleteSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCompleteSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconComplete",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCompleteSolid.displayName = "IconCompleteSolid";
  return IconCompleteSolid;
}(Component);

IconCompleteSolid.glyphName = 'complete';
IconCompleteSolid.variant = 'Solid';
IconCompleteSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCompleteSolid;
export { IconCompleteSolid };